export const getMapData = (): Promise<any> => new Promise(async (resolve) => {
  const url = 'https://wotcodeapi.azurewebsites.net/wotmud-map.json';
  const data = await fetch(url).then(resp => resp.json());
    
  //transform data
  data.areasById = [];
  data.roomsById = [];
  data.labelsById = [];
  data.areaOptions = [];
  data.roomOptions = [];

  //resolve when all images are loaded
  let imageCount = 0;
  const onload = () => {
    if (--imageCount === 0) {
      resolve(data);
    }
  };

  //normalize areas
  for (let area of data.areas) {
    data.areasById[area.id] = area;
    area.rooms = area.rooms ?? [];
    area.labels = area.labels ?? [];
    area.levels = [];
    area.levelsById = [];
    area.levelOptions = [];

    //create area dropdown options
    if (!area.name.includes('removed') && area.name !== 'Default Area' && area.name !== 'TESTING1') {
      data.areaOptions.push({ value: area.id, text: area.name });
    }

    //normalize rooms
    for (let room of area.rooms) {
      data.roomsById[room.id] = room;
      room.areaId = area.id;
      room.coordinates[1] *= -1;
      data.roomOptions.push({ value: room.id, label: room.id + ': ' + room.name });

      //synthesize levels
      const levelId = room.coordinates[2];
      let level = area.levelsById[levelId];
      if (!level) {
        level = { id: levelId, name: (levelId / 3).toString(), rooms: [] };
        area.levels.push(level);
        area.levelsById[level.id] = level;
        area.levelOptions.push({ value: level.id, text: level.name });
      }
      level.rooms.push(room);
    }
    
    //normalize areas
    for (let label of area.labels) {
      data.labelsById[label.id] = label;
      label.areaId = area.id;
      label.coordinates[1] *= -1;

      //load images
      const image = label.image.join('');
      if (image) {
        label.htmlImage = new Image();
        label.htmlImage.src = 'data:image/png;base64,' + image;
        label.htmlImage.addEventListener('load', onload);
        imageCount++;
      }
    }
    
    area.levels.sort((a: any, b: any) => a.value - b.value);
    area.levelOptions.sort((a: any, b: any) => a.value - b.value);
  }

  data.areaOptions.sort((a: any, b: any) => a.text.localeCompare(b.text));
  data.roomOptions.sort((a: any, b: any) => a.label.localeCompare(b.label));
});